<template>
  <div>
    <b-icon
      icon="x-octagon"
      variant="danger"
      animation="throb"
      font-scale="8"
    />
    <hr />
    <h3 class="mb-0">{{ $t("general.sure") }}</h3>
    <p> 
      Bir Receiver Protokolüne ait formatları farklı bir Receiver Protokolüne kopyalamak üzeresiniz. Bu işlem mevcuttaki Receiver
      Formatlarının üzerine yazılmaktadır. Yapılan yanlış kopyalama işleminin geriye alınması mümkün değildir ve yanlış yapılan 
      işlem, Receiverınızdan sinyal alamamayı veya alınan sinyalin yanlış parçalanması nedeniyle farklı abonelerde görünmesini 
      ya da geçersiz abone olarak algınlanması nedeniyle sinyal kaybına sebep olabilir. Lütfen kopyalanmasını istediğiniz ve 
      kopyalanacak protokolü aşağıdan seçiniz.
    </p>
    <form ref="form">
        <b-form-group>
            <b-row>
                <b-col sm="6"> Bilgilerin Alınacağı Protokol  </b-col>
                <b-col sm="6"> 
                  <Multiselect v-model="receiver_protocol" :show-labels="false" :options="protocol"
                    label="name" track-by="id">
                          <template slot="singleLabel" slot-scope="{ option }">
                              <strong>{{ option.name }} </strong> 
                          </template>
                  </Multiselect>
                </b-col>
            </b-row>
             <b-row>
                <b-col sm="6"> Bilgilerin Yapıştırılacağı Protokol (Çakışma durumunda kopyalanan bilgiler doğru kabul edilir.) </b-col>
                <b-col sm="6">
                  <Multiselect v-model="copy_receiver_protocol" :show-labels="false" :options="protocol"
                    label="name" track-by="id">
                          <template slot="singleLabel" slot-scope="{ option }">
                              <strong>{{ option.name }} </strong> 
                          </template>
                  </Multiselect>
                </b-col>
            </b-row>
        </b-form-group>
    </form>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
export default {
  name: "CopyFormat",
  props: {
    data: Object,
    modalName: String,
    modalEvent: Function,
    save: Boolean,
    saveState: Function,
    formName: String
  },
  components:{
      Multiselect
  },
  computed:{
      protocol(){
          return this.$store.getters.getReceiverProtocols;
      },
      loading(){
          return this.$store.getters.getDefinationLoading;
      }
  },
  data: function(){
    return {
      receiver_protocol: null,
      copy_receiver_protocol: null,
    }
  },
  watch: {
    save: async function(data) {

      if (data) {
        if(this.receiver_protocol && this.copy_receiver_protocol){
           let val = {
              "from_protocol_id": this.receiver_protocol.id,
              "to_protocol_id": this.copy_receiver_protocol.id
            }
            await this.$store.dispatch("copyRecProtocol", val);
            await this.$store.dispatch("listRecProtocols");  
            this.modalEvent(false);
        }else{
           this.$bvToast.toast('Lütfen tüm alanları doğru bir şekilde doldurunuz', {
              title: 'Dikkat',
              variant: 'danger',
              solid: true
          })
        }

      }
      this.saveState(false);
  
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/General/Defination/modals/ReceiverFormatCopy.vue